import iconTask from '../assets/icon.png'
import iconPdfnote from '../assets/pdfnoteblack.png'
import iconShell from '../assets/shell.png'
import iconArchive from '../assets/archive/archive.png'
import taskWeb from '../assets/task/web_home.png'
import taskIphone from '../assets/task/iphone_home.png'
import taskIpad from '../assets/task/ipad_home.png'
import taskIpadTime from '../assets/task/ipad_time.png'
import taskFour from '../assets/task/iphone_four.png'
import taskCal1 from '../assets/task/iphone_cal1.png'
import taskCal2 from '../assets/task/iphone_cal2.png'
import taskType from '../assets/task/type.png'
import pdfnoteMac from '../assets/pdfnote/1-mac.png'
import pdfnoteIpad from '../assets/pdfnote/1-ipad.png'
import pdfnoteIphone from '../assets/pdfnote/1-iphone.png'
import pdfnoteMac2 from '../assets/pdfnote/2-mac.png'
import pdfnoteIpad2 from '../assets/pdfnote/2-iphone.png'
import pdfnoteIpad3 from '../assets/pdfnote/3-ipad.png'
import pdfnoteMac4 from '../assets/pdfnote/4-mac.png'
import pdfnoteWeb5 from '../assets/pdfnote/5-web.png'
import shellMac1 from '../assets/xingshell/1-mac.png'
import shellIpad1 from '../assets/xingshell/1-ipad.png'
import shellIpad2 from '../assets/xingshell/2-ipad.png'
import shellIpad4 from '../assets/xingshell/4-ipad.png'
import shellIphone1 from '../assets/xingshell/1-iphone.png'

export const legalDocs = [
  { title: '任务百分比隐私政策', link: '/document/task/privacy' },
  { title: '任务百分比使用条款', link: '/document/task/agreement' },
  { title: '彩思笔记隐私政策', link: '/document/pdfnote/privacy' },
  { title: '彩思笔记使用条款', link: '/document/pdfnote/agreement' },
  { title: '星终端隐私政策', link: '/document/xingshell/privacy' },
  { title: '星终端使用条款', link: '/document/xingshell/agreement' },
  { title: '彩幸档案库隐私政策', link: '/document/archive/privacy' },
  { title: '彩幸档案库使用条款', link: '/document/archive/agreement' },
]

export const products = [
  {
    id: 'task',
    name: '任务百分比',
    mark: '任务百分比可在不同系统设备无缝使用,以百分比直观展示任务进度,云端同步助你高效管理任务',
    features: ['任务进度', '多端同步', '百分比管理'],
    logo: iconTask,
    links: {
      web: 'https://www.colorthinking.com/task',
      ios: 'https://apps.apple.com/cn/app/%E4%BB%BB%E5%8A%A1%E7%99%BE%E5%88%86%E6%AF%94/id6746470843',
    },
    apk: {
      url: 'https://www.colorthinking.com/files/task.apk',
      filename: '任务百分比.apk',
    },
    buttons: ['ios', 'android', 'web'],
    page: {
      hero: {
        title: '让进度，一目了然',
        subtitle: '任务百分比用最直观的方式呈现每件事的进展——不靠感觉，靠数字。从今日待办到长期目标，每一步都清晰可见。',
        devices: [
          { image: taskWeb, kind: 'web' },
          { image: taskIphone, kind: 'phone' },
        ],
      },
      features: [
        {
          title: '耗时统计，看见时间去向',
          desc: '进度页自动累计每个任务的总耗时，精确到分钟，所有任务的时间占比一目了然。学一门语言坚持了 60 天，一个项目冲刺了 17 天——你的每一份投入，数字都替你记得。',
          visual: { image: taskIpadTime, kind: 'pad' },
        },
        {
          title: '日历，八种视角随心切换',
          desc: '一天、三天、一周、两周、整月，加上 4×6、5×5、3×8 三种 24 小时矩阵视图——从一天的精细颗粒到整月的全局规划，视角随心变焦。公历与农历同屏显示，本周的节奏、整月的全貌，尽收眼底。',
          visual: { frame: 'dual', images: [taskCal1, taskCal2], typeImage: taskType },
        },
        {
          title: '四象限，分清轻重缓急',
          desc: '重要且紧急、重要不紧急、紧急不重要、不重要不紧急——四色象限让所有任务自动归位。先做什么、后做什么，一眼就有答案。',
          flip: true,
          visual: { image: taskFour, kind: 'phone' },
        },
        {
          title: '多端无缝同步',
          desc: 'iPhone、iPad、Android 与网页端，任何设备上的改动都会实时同步。在公司记一笔，路上掏出手机就能接着推进。',
          visual: { frame: 'trio' },
        },
      ],
      trio: [
        { image: taskIpad, kind: 'pad' },
        { image: taskWeb, kind: 'web' },
        { image: taskIphone, kind: 'phone' },
      ],
      cta: {
        title: '开始用百分比管理你的任务',
        desc: '支持 iPhone、iPad、Android 与网页端。',
      },
    },
  },
  {
    id: 'pdfnote',
    name: '彩思笔记',
    mark: '彩思笔记是一款跨平台的PDF笔记应用,实时增量同步用户的标注笔记,帮助用户高效管理PDF和笔记',
    features: ['PDF 标注', '增量同步', '桌面端支持'],
    logo: iconPdfnote,
    links: {
      web: 'https://www.colorthinking.com/pdfnote',
      ios: 'https://apps.apple.com/app/6756973642',
    },
    apk: {
      url: 'https://www.colorthinking.com/files/pdfnote.apk',
      filename: '彩思笔记.apk',
    },
    desktopDownloads: [
      { id: 'macos-universal', title: 'macOS', icon: 'mdi-apple', color: 'orange-darken-2', url: '/files/pdfnote-macos-universal.dmg' },
      { id: 'windows-x64', title: 'Win x64', icon: 'mdi-microsoft-windows', color: 'indigo', url: '/files/pdfnote-windows-x64.exe' },
      { id: 'windows-arm64', title: 'Win ARM64', icon: 'mdi-microsoft-windows', color: 'teal', url: '/files/pdfnote-windows-arm64.exe' },
    ],
    buttons: ['web', 'ios', 'android', 'desktop'],
    page: {
      hero: {
        title: '在 PDF 上，自由思考',
        subtitle: '彩思笔记是一款跨平台的 PDF 笔记应用。高亮重点、随手批注，所有笔记实时增量同步，你的想法在任何设备上都触手可及。',
        devices: [
          { image: pdfnoteMac2, kind: 'mac' },
          { image: pdfnoteIpad2, kind: 'phone' },
        ],
      },
      features: [
        {
          title: '所有文档，一处归集',
          desc: '论文、技术书籍、高清字帖——导入后统一管理，文件夹自由分类，封面缩略图让书架一目了然。文件存于云端、按需下载，iPad 上标记的已同步状态，换台设备依然清晰。',
          visual: { frame: 'triple', images: [pdfnoteIpad, pdfnoteMac, pdfnoteIphone] },
        },
        {
          title: '标注，像在纸上一样自然',
          desc: '高亮、下划线、批注——丰富的标注工具让阅读和思考同步进行，每一份文档都成为你的思考记录。',
          visual: { image: pdfnoteIpad3 },
        },
        {
          title: '多种笔触，自由搭配',
          desc: '高亮、下划线、批注——丰富的标注工具让阅读和思考同步进行，每一份文档都成为你的思考记录。',
          flip: true,
          visual: { image: pdfnoteMac4 },
        },
        {
          title: '文档笔记，独立笔记统一管理',
          desc: '文档之外的独立笔记同样集中管理，分类清晰、随时查阅，思考的碎片也有处安放。',
          visual: { image: pdfnoteWeb5 },
        },
      ],
      cta: {
        title: '让每一份 PDF 都留下你的思考',
        desc: '支持 iOS、Android、Windows、macOS 与网页端。',
      },
    },
  },
  {
    id: 'xingshell',
    name: '星终端',
    mark: '星终端(XingShell)是一款易用的远程Shell应用,通过SSH和Sftp帮助用户高效管理远程服务器',
    features: ['SSH 连接', 'SFTP 文件', '服务器管理'],
    logo: iconShell,
    links: {
      web: '#',
      ios: 'https://apps.apple.com/us/app/%E6%98%9F%E7%BB%88%E7%AB%AF/id6796329241',
    },
    androidDisabled: true,
    desktopDownloads: [
      { id: 'macos-universal', title: '苹果电脑端', icon: 'mdi-apple', color: 'orange-darken-2', url: '/xingshell/download/XingShell_1.0.2_universal.dmg' },
      { id: 'windows-x64', title: 'Win x64', icon: 'mdi-microsoft-windows', color: 'blue-darken-1', url: '/xingshell/download/XingShell_1.0.2_x64-setup.exe' },
    ],
    buttons: ['ios', 'android', 'desktop'],
    page: {
      hero: {
        title: '把服务器，装进口袋',
        subtitle: '星终端（XingShell）是一款易用的远程 Shell 应用。SSH 连接、SFTP 文件管理，让你随时随地掌控远程服务器。',
        devices: [
          { image: shellMac1, kind: 'mac' },
          { image: shellIphone1, kind: 'phone' },
        ],
      },
      features: [
        {
          title: 'SFTP 文件管理',
          desc: '浏览、上传、下载远程文件，像操作本地文件夹一样简单。',
          visual: { image: shellIpad2, kind: 'pad' },
        },
        {
          title: 'SSH，随时在线',
          desc: '在 iPhone 或 iPad 上安全连接远程服务器，执行命令、查看状态。出门在外，也能第一时间响应。',
          flip: true,
          visual: { image: shellIpad1, kind: 'pad' },
        },
        {
          title: '服务器监控，进程监控',
          desc: 'CPU、内存、进程状态实时呈现，服务器负载一屏掌握。出门在外，也能随时了解每台服务器的运行状况。',
          visual: { image: shellIpad4, kind: 'pad' },
        },
      ],
      cta: {
        title: '随时随地，连接你的服务器',
        desc: '支持 Windows、macOS、iPhone 与 iPad。',
      },
    },
  },
  {
    id: 'archive',
    name: '彩幸档案库',
    mark: '彩幸档案库是一款专业电子档案库应用,多平台实时同步,帮助你安全、高效地管理个人档案',
    features: ['电子档案', '多端同步', '安全加密'],
    logo: iconArchive,
    links: {
      web: 'https://www.colorthinking.com/archive/',
    },
    iosDisabled: true,
    androidDisabled: true,
    buttons: ['web', 'ios', 'android'],
    page: {
      hero: {
        title: '妥善整理每一份重要记录',
        subtitle: '彩幸档案库是一款专业的电子档案库应用。加密存储、分类管理、多端同步，让每一份重要记录都被妥善保管、随时可查。',
        devices: [],
      },
      features: [],
      cta: {
        title: '让每一份记录都有迹可循',
        desc: '即将登陆 App Store，支持 iPhone 与 iPad。',
      },
    },
  },
]
